import {LocalBusinessJsonLd} from "next-seo";
import Head from 'next/head';
import {
    BUSINESS_NAME,
    contactDetails,
    defaultMetaTags,
    googleDetails,
    socialMediaProfiles,
    WEBSITE_URL,
    businessDetails
} from "@/content";


const LocalBusinessSeo = () =>{
    return (<><LocalBusinessJsonLd
        type="LocalBusiness"
        id={WEBSITE_URL}
        name={BUSINESS_NAME}
        description={defaultMetaTags.description}
        url={WEBSITE_URL}
        telephone={contactDetails.contactNumberOne}
        address={[{
            streetAddress: businessDetails.address.streetAddress,
            addressLocality:businessDetails.address.addressLocality,
            addressRegion: businessDetails.address.addressRegion,
            postalCode: businessDetails.address.postalCode,
            addressCountry:businessDetails.address.addressCountry
        }]}
        images={[
            defaultMetaTags.ogImage,
        ]}
        sameAs={[
            `${socialMediaProfiles.facebookLink}${socialMediaProfiles.facebookHandle}`,
        ]}
    />
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "name": BUSINESS_NAME,
                            "image": defaultMetaTags.ogImage,
                            "@type": "LocalBusiness",
                            "areaServed": {
                                "@type": "Place",
                                "name": googleDetails.areaServed,
                            },
                            "address":businessDetails.address
                        }),
                    }}
                />
            </Head>
        </>
    )
}

export default LocalBusinessSeo
